/**
 * Homepage / collection product-card ATC → ajax add + open cart drawer.
 */
(function () {
  function onClick(event) {
    const button = event.target.closest('.product-card__atc');
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    event.preventDefault();
    const variantId = button.getAttribute('data-variant-id');
    if (!variantId || typeof window.addToCart !== 'function') return;

    const original = button.textContent;
    button.classList.add('is-loading');
    button.disabled = true;

    window
      .addToCart(variantId, 1, {}, function () {
        document.dispatchEvent(new CustomEvent('addtocart'));
        button.textContent = 'Added';
        setTimeout(function () {
          button.textContent = original;
        }, 1200);
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.disabled = false;
      });
  }

  document.addEventListener('click', onClick);
})();
